<template>
	<div
			class="image-and-text-block__container"
			:class="[
						componentData.data.width === ComponentWidthEnum.FIX_1200 ? 'divider__fix-width' : '',
						'image-and-text-block__container--' + componentData.data.layout
					]"
	>
		<div v-for="(block, index) in componentData.data.blocks" :key="index" class="image-and-text-block__item mb-4">
			<div
					class="image-and-text-block__image-container"
					v-lazy-bg="imagePath('path', block)"
					:style="{ backgroundSize: block.imageFit ?? 'cover' }"
			>
				<img v-if="block?.icon?.image || block.icon?.webp" :src="imagePath('icon', block)" :srcset="block.icon?.srcset" :sizes="block.icon?.srcset ? '32px' : undefined" alt="icon" class="image-and-text-block__icon">
			</div>
			<dynamic-heading v-if="block?.title" :level="componentData.heading_level" :default-level="3" class="image-and-text-block__title">{{ block.title }}</dynamic-heading>
			<p v-if="block?.description" class="image-and-text-block__description" v-html="block.description"></p>
			<a v-if="!!block.button?.text && !!block.button?.link" :href="block.button.link" class="link-block">
				<button-unit
						class="image-and-text-block__button"
						:options="{
								text: block.button.text,
								type: 'button',
								shape: '',
								textColor: block.button.color,
								bgColor: block.button.background,
						}"
				/>
			</a>
			<button-unit
					v-else-if="!!block.button?.text"
					class="image-and-text-block__button"
					:options="{
							text: block.button.text,
							type: 'button',
							shape: '',
							textColor: block.button.color,
							bgColor: block.button.background,
					}"
			/>
		</div>
	</div>
</template>

<style scoped lang="scss">
.image-and-text-block__item {
	box-shadow: v-bind(shadowState);
}


</style>

<script setup lang="ts">
import {computed, defineProps, PropType} from "vue";
import {pickImageUrl} from "@/WebApp/Utils/ResponsiveImage";
import {IImageAndTextBlockBoxComponent} from "@SharedInterfaces/ImageAndTextBlockComponent";
import ButtonUnit from "@/WebApp/Components/Units/ButtonUnit.vue";
import DynamicHeading from "@/WebApp/Components/Units/DynamicHeading.vue";
import {ComponentWidthEnum} from "@SharedEnums/ComponentWidthEnum";

const props = defineProps({
	componentData: {
		type: Object as PropType<IImageAndTextBlockBoxComponent>,
		default: {},
		required: true,
	},
});
const imagePath = (property, image) => {
	return pickImageUrl(image[property]);
}

const shadowState = computed(() => {
	if (props.componentData?.data?.shadow ?? true) {
		return '0px 4px 6px 0px rgba(0, 0, 0, 0.12';
	}
	return 'none';
});

</script>
